import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

const { clientId, codeVerifier, tokenAzureBaseUrl, authTokenScope, local, loginAzureBaseUrl} = environment;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private httpClient: HttpClient) { }

  exchangeCodeForToken(code: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    const body = new HttpParams()
      .set('client_id', clientId)
      .set('scope', authTokenScope)
      .set('code', code)
      .set('redirect_uri', AuthService.getTokenRedirectUri())
      .set('grant_type', 'authorization_code')
      .set('code_verifier', codeVerifier);

    return this.httpClient.post(
      tokenAzureBaseUrl,
      body.toString(),
      { headers }
    )
  }

  static getLoginAzureUrl() {
    const loginAzureParams = new URLSearchParams([
      ["client_id", clientId],
      ["response_type", "code"],
      ["redirect_uri", AuthService.getTokenRedirectUri()],
      ["response_mode", "query"],
      ["scope", "profile email openid"],
      ["prompt", "login"],
      ["code_challenge", codeVerifier],
      ["code_challenge_method", "plain"]
    ]).toString();

    return `${loginAzureBaseUrl}?${loginAzureParams.toString()}`
  }

  static getTokenRedirectUri() {
    let protocol = local ? 'http': 'https'
    return `${protocol}://${AuthService.getHost()}/auth`;
  }

  static getHost() {
    let host = window.location.host;
    return host.endsWith('.') ? host.slice(0, -1) : host;
  }
}
